import { borderStyles, globalStyles } from 'styles/theme';

import { Collapse as AntdCollapse } from 'antd';
import FlexContainer from 'components/common/FlexContainer';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled(FlexContainer)({
  margin: '80px 25%',
  gap: 32,
  [mobileMediaQuery]: {
    margin: '80px 20px',
  },
});

export const SectionsContainer = styled(FlexContainer)({
  gap: 80,
  [mobileMediaQuery]: {
    gap: 60,
  },
});

export const Heading = styled.span({
  fontSize: 32,
  lineHeight: '40px',
  [mobileMediaQuery]: {
    fontSize: 26,
    lineHeight: '30px',
  },
});

export const Question = styled.span({
  fontSize: 20,
  [mobileMediaQuery]: {
    fontSize: 16,
  },
});

export const NavContainer = styled(FlexContainer)({
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const AnswersContainer = styled(FlexContainer)({
  paddingBottom: 36,
});

export const Collapse = styled(AntdCollapse)({
  backgroundColor: 'transparent',
  borderColor: borderStyles.colors.secondary,
  borderStyle: 'solid',
  borderWidth: '1px 0px',
  '&& div.ant-collapse-item > div.ant-collapse-header': {
    padding: '36px 0px',
    [mobileMediaQuery]: {
      padding: '24px 0px',
    },
  },
  '&& div.collapse-panel-content': {
    paddingBottom: 36,
    [mobileMediaQuery]: {
      paddingBottom: 24,
    },
  },
  '&& div.ant-collapse-header:hover > span.ant-collapse-header-text': {
    color: globalStyles.colors.primary,
  },
  '&& div.ant-collapse-header:hover > div.ant-collapse-expand-icon > svg': {
    filter: 'invert(14%) sepia(92%) saturate(5314%) hue-rotate(267deg) brightness(85%) contrast(91%)',
  },
  '&& span.ant-collapse-header-text': {
    [mobileMediaQuery]: {
      width: '90%',
    },
  },
  '&& div.ant-collapse-content > div.ant-collapse-content-box': {
    padding: 0,
  },
});
